// @flow
import React from 'react';
import moment from 'moment';
// material
import { TableRow, TableRowColumn } from 'material-ui/Table';
import '../ui/table.css';
import './main.css';

const setState = (state) => {
    const stateTranslate = {
        draft: 'Черновик',
        available: 'Опубликовано',
        deleted: 'Удалено',
    };
    return stateTranslate[state];
};

type Article = {
    id: string,
    title: string,
    section: string,
    sectionName: string,
    availableAt: Date,
    state: string,
    authorName: ?string,
}

const MainListItem = (args: {history: Object, article: Article}) => {
    const { history, article } = args;
    const redirect = () => {
        history.push(`/articles/${article.section}/${article.id}`);
    };
    return (
        <TableRow
            onClick={redirect}
            style={{ border: 0 }}
        >
            <TableRowColumn className="table--cell table--cell-body articles-table--date">
                {moment(article.availableAt).format('HH:mm')}
                <br />
                {moment(article.availableAt).format('DD.MM.YYYY')}
            </TableRowColumn>
            <TableRowColumn className="table--cell table--cell-body articles-table--title">
                <div className="table-fix-cell">{article.title}</div>
            </TableRowColumn>
            <TableRowColumn className="table--cell table--cell-body articles-table--author">
                {article.authorName}
            </TableRowColumn>
            <TableRowColumn className="table--cell table--cell-body articles-table--info-main">
                {article.sectionName.replace('Новости 78', 'Новость').replace('Статьи', 'Статья')}
            </TableRowColumn>
            <TableRowColumn className="table--cell table--cell-body articles-table--state-main">
                {setState(article.state)}
            </TableRowColumn>
        </TableRow>
    );
};

export default MainListItem;



// WEBPACK FOOTER //
// src/components/main/MainListItem.js